import React, { useEffect, useRef } from 'react';

/**
 * Simple Trajectory Projection Animation
 * Visual representation of rocket trajectory
 */
const ProjectionAnimation = ({ launchDate }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width = 600;
    const height = canvas.height = 400;

    // Clear canvas
    ctx.fillStyle = '#0a0a0a';
    ctx.fillRect(0, 0, width, height);

    // Draw stars background
    ctx.fillStyle = '#ffffff';
    for (let i = 0; i < 100; i++) {
      const x = Math.random() * width;
      const y = Math.random() * height;
      ctx.fillRect(x, y, 1, 1);
    }

    // Draw Earth (bottom)
    ctx.beginPath();
    ctx.arc(width / 2, height - 20, 30, 0, Math.PI * 2);
    ctx.fillStyle = '#4a9eff';
    ctx.fill();
    ctx.strokeStyle = '#2d5aa0';
    ctx.lineWidth = 2;
    ctx.stroke();

    // Draw trajectory curve
    ctx.beginPath();
    ctx.moveTo(width / 2, height - 50);
    ctx.quadraticCurveTo(width * 0.3, height * 0.3, width * 0.7, height * 0.1);
    ctx.strokeStyle = '#e94560';
    ctx.lineWidth = 3;
    ctx.stroke();

    // Draw rocket on trajectory
    const progress = (Date.now() % 5000) / 5000; // Animate over 5 seconds
    const t = progress;
    const x = width / 2 + (width * 0.7 - width / 2) * t + (width * 0.3 - width / 2) * 2 * t * (1 - t);
    const y = (height - 50) * (1 - t) + height * 0.1 * t;
    
    // Rocket body
    ctx.fillStyle = '#ff6b6b';
    ctx.fillRect(x - 5, y - 15, 10, 20);
    
    // Rocket nose
    ctx.beginPath();
    ctx.moveTo(x - 5, y - 15);
    ctx.lineTo(x, y - 25);
    ctx.lineTo(x + 5, y - 15);
    ctx.fill();

    // Rocket exhaust
    ctx.beginPath();
    ctx.moveTo(x - 5, y + 5);
    ctx.lineTo(x - 8, y + 15);
    ctx.lineTo(x, y + 8);
    ctx.lineTo(x + 8, y + 15);
    ctx.lineTo(x + 5, y + 5);
    ctx.fillStyle = '#ffa500';
    ctx.fill();

    // Animation loop
    const interval = setInterval(() => {
      ctx.fillStyle = '#0a0a0a';
      ctx.fillRect(0, 0, width, height);

      // Redraw stars
      ctx.fillStyle = '#ffffff';
      for (let i = 0; i < 100; i++) {
        const x = Math.random() * width;
        const y = Math.random() * height;
        ctx.fillRect(x, y, 1, 1);
      }

      // Redraw Earth
      ctx.beginPath();
      ctx.arc(width / 2, height - 20, 30, 0, Math.PI * 2);
      ctx.fillStyle = '#4a9eff';
      ctx.fill();
      ctx.strokeStyle = '#2d5aa0';
      ctx.lineWidth = 2;
      ctx.stroke();

      // Redraw trajectory
      ctx.beginPath();
      ctx.moveTo(width / 2, height - 50);
      ctx.quadraticCurveTo(width * 0.3, height * 0.3, width * 0.7, height * 0.1);
      ctx.strokeStyle = '#e94560';
      ctx.lineWidth = 3;
      ctx.stroke();

      // Update rocket position
      const newProgress = (Date.now() % 5000) / 5000;
      const newT = newProgress;
      const newX = width / 2 + (width * 0.7 - width / 2) * newT + (width * 0.3 - width / 2) * 2 * newT * (1 - newT);
      const newY = (height - 50) * (1 - newT) + height * 0.1 * newT;

      // Rocket body
      ctx.fillStyle = '#ff6b6b';
      ctx.fillRect(newX - 5, newY - 15, 10, 20);

      // Rocket nose
      ctx.beginPath();
      ctx.moveTo(newX - 5, newY - 15);
      ctx.lineTo(newX, newY - 25);
      ctx.lineTo(newX + 5, newY - 15);
      ctx.fill();

      // Rocket exhaust
      ctx.beginPath();
      ctx.moveTo(newX - 5, newY + 5);
      ctx.lineTo(newX - 8, newY + 15);
      ctx.lineTo(newX, newY + 8);
      ctx.lineTo(newX + 8, newY + 15);
      ctx.lineTo(newX + 5, newY + 5);
      ctx.fillStyle = '#ffa500';
      ctx.fill();
    }, 50);

    return () => clearInterval(interval);
  }, [launchDate]);

  return (
    <div style={{ textAlign: 'center', margin: '20px 0' }}>
      <h3>Launch Trajectory Projection</h3>
      <canvas ref={canvasRef} style={{ border: '2px solid var(--accent-color)', borderRadius: '10px', display: 'block', margin: '0 auto' }} />
    </div>
  );
};

export default ProjectionAnimation;
